import styled from 'styled-components';
import { StyledDivider, StyledGrid, StyledPaper, StyledTypography } from 'styles/common';

import {
  AngryColoredEmojiIcon,
  HappyColoredEmojiIcon,
  SadColoredEmojiIcon,
  SmartColoredEmojiIcon,
  StarIcon,
  VeryHappyColoredEmojiIcon,
} from 'constants/icons';
import theme from 'constants/theme';

import { EmptyBar } from '../commonComponents';

const HoverComponent = ({ managerName = 'Manager', count, distributionData, StatRowComp }) => (
  <StyledPaper padding="1rem" style={{ width: '40ch' }}>
    <StyledGrid container alignItems="center" justify="space-between">
      <StyledTypography variant="body1" weight={600}>
        {managerName}
      </StyledTypography>
      <StyledTypography variant="body1" color="textSecondary">
        Total <span style={{ color: theme.palette.text.primary }}> {count}</span>
      </StyledTypography>
    </StyledGrid>

    <StyledDivider bottomGutter={2} topGutter={2} />
    {distributionData.map(({ rating, description, numberOfEmployees, percentage }) => (
      <StatRowComp
        key={rating}
        rating={rating}
        count={String(numberOfEmployees).padStart(2, 0)}
        percentage={String(Math.round(percentage)).padStart(2, 0)}
        description={description}
      />
    ))}
  </StyledPaper>
);

const RatingStatRow = ({ rating, count, percentage }) => (
  <RowContainer>
    <StyledGrid container item xs={8} alignItems="center">
      {rating === 0 ? (
        <EmptyBar />
      ) : (
        Array(rating)
          .fill(1)
          .map((_, ind) => <StarIcon key={ind} size="header" color="mustard" rightGutter={1} />)
      )}
    </StyledGrid>
    <StyledGrid item xs={2}>
      <StyledTypography variant="body2">{count}</StyledTypography>
    </StyledGrid>
    <StyledGrid item xs={2}>
      <StyledTypography variant="body2" color="textSecondary">
        {`${percentage} %`}
      </StyledTypography>
    </StyledGrid>
  </RowContainer>
);

export const getSmileyComponent = (rating, size = 'header') => {
  switch (rating) {
    case 1:
      return <AngryColoredEmojiIcon size={size} />;
    case 2:
      return <SadColoredEmojiIcon size={size} />;
    case 3:
      return <SmartColoredEmojiIcon size={size} />;
    case 4:
      return <HappyColoredEmojiIcon size={size} />;
    case 5:
      return <VeryHappyColoredEmojiIcon size={size} />;
    default:
      return <EmptyBar />;
  }
};

const SmileyStatRow = ({ rating, description, count, percentage }) => (
  <RowContainer>
    <StyledGrid container item xs={8} alignItems="center">
      {getSmileyComponent(rating)}
      <StyledTypography leftGutter={1} variant="body2" color="textSecondary" truncate>
        {description}
      </StyledTypography>
    </StyledGrid>
    <StyledGrid item xs={2}>
      <StyledTypography variant="body2">{count}</StyledTypography>
    </StyledGrid>
    <StyledGrid item xs={2}>
      <StyledTypography variant="body2" color="textSecondary">
        {`${percentage} %`}
      </StyledTypography>
    </StyledGrid>
  </RowContainer>
);

const RowContainer = styled(StyledGrid).attrs((props) => ({
  bottomGutter: 2,
  container: true,
  alignItems: 'center',
}))`
  &:last-child {
    margin-bottom: 0.5rem;
  }
`;

export const RatingHover = ({ managerName, count, ratingDistributionData }) => (
  <HoverComponent
    managerName={managerName}
    count={count}
    distributionData={ratingDistributionData}
    StatRowComp={RatingStatRow}
  />
);

export const SmileyHover = ({ managerName, count, smileyDistributionData }) => (
  <HoverComponent
    managerName={managerName}
    count={count}
    distributionData={smileyDistributionData}
    StatRowComp={SmileyStatRow}
  />
);
